<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1" />
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
      <!-- 新增所属机构显示 -->
      <div class="org-display-card">
        <i class="el-icon-office-building org-icon"></i>
        <span class="org-label">当前所属机构：</span>
        <span class="org-value">{{ currentDepartmentName || '全部' }}</span>
      </div>
      <div class="tbl-scroll-host">
      <el-table v-loading="listLoading" :data="list" height="100%" style="width: 100%" highlight-current-row
        @row-click="selectCurrentRow" ref="table">
        <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
        <el-table-column prop="GradeName" label="年级" min-width="120" align="center"></el-table-column>
        <el-table-column prop="PeriodName" label="时段名称" min-width="110" align="center"></el-table-column>
        <el-table-column label="关联标签" min-width="200" align="left">
          <template slot-scope="scope">
            <div v-if="configTagsOfRow(scope.row).length" class="config-tag-pills">
              <span
                v-for="(t, idx) in configTagsOfRow(scope.row)"
                :key="'link-' + scope.row.Id + '-' + idx"
                class="config-tag-pill"
              >{{ configTagLabel(t) }}</span>
            </div>
            <span v-else class="config-tag-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="默认勾选" min-width="168" align="left">
          <template slot-scope="scope">
            <div v-if="defaultTagsOfRow(scope.row).length" class="config-tag-pills">
              <span
                v-for="(t, idx) in defaultTagsOfRow(scope.row)"
                :key="'def-' + scope.row.Id + '-' + idx"
                class="config-tag-pill config-tag-pill--default"
              >{{ configTagLabel(t) }}</span>
            </div>
            <span v-else class="config-tag-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="DismissalTime" label="放学时间" width="120" align="center">
          <template slot-scope="scope">
            <span class="time-badge">
              <i class="el-icon-time time-icon"></i>
              {{ scope.row.DismissalTime }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="DisplayDurationMinutes" label="显示时长(分)" width="110" align="center"></el-table-column>
        <el-table-column prop="PreDismissalMinutes" label="提前进入时段(分)" width="140" align="center"></el-table-column>
        <!-- <el-table-column prop="SelfRetainedThresholdMinutes" label="自留阈值(分)" min-width="140"
          align="center"></el-table-column> -->
        <el-table-column prop="StatisticalWindowMinutes" label="统计窗口(分)" width="110"
          align="center"></el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination
          layout="total, prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          style="float: right"
        />
      </div>

      <!-- Dialog -->
      <el-dialog
        :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        width="48%"
      >
        <el-form ref="dataForm" :rules="rules" :model="temp" label-position="right" label-width="140px"
          style="width: 100%; padding-right: 20px">
          
          <el-tabs v-model="activeTab" class="dialog-tabs">
            <el-tab-pane name="base">
              <span slot="label"><i class="el-icon-info"></i> 基础配置</span>
              
              <el-form-item label="年级" prop="GradeId">
                <el-select
                  v-model="temp.GradeId"
                  placeholder="请选择年级"
                  style="width: 100%"
                  :disabled="dialogStatus === 'update'"
                  @change="onGradeChange"
                >
                  <el-option v-for="item in gradeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              
              <el-form-item label="时段名称" prop="PeriodName">
                <el-input v-model="temp.PeriodName" placeholder="如：中午放学、下午放学"></el-input>
              </el-form-item>
              
              <el-form-item label="关联标签">
                <el-select
                  v-model="selectedConfigTagIds"
                  multiple
                  filterable
                  clearable
                  :loading="tagSelectLoading"
                  placeholder="不选表示整班放学（不分列）"
                  style="width: 100%"
                  @change="onConfigTagsChange"
                  @visible-change="onTagSelectVisible"
                >
                  <el-option
                    v-for="t in campusDismissalTags"
                    :key="t.id"
                    :label="t.displayName || (t.categoryName ? t.categoryName + '：' + t.tagName : t.tagName)"
                    :value="t.id"
                  />
                </el-select>
                <div v-if="tagSelectHint" class="tag-select-hint" :class="'tag-select-hint--' + tagSelectHintType">
                  <i class="el-icon-warning-outline"></i> {{ tagSelectHint }}
                </div>
                <div v-else class="helper-desc">
                  <i class="el-icon-info"></i> 仅可选「应用于放学」且启用的标签；H5 按所选标签分列。标签按年级所属校区加载。
                </div>
              </el-form-item>
              
              <el-form-item v-if="selectedConfigTagIds.length" label="默认勾选标签">
                <el-checkbox-group v-model="defaultConfigTagIds" class="modern-checkbox-group">
                  <el-checkbox
                    v-for="t in selectedDismissalTags"
                    :key="t.id"
                    :label="t.id"
                    border
                  >{{ t.displayName || (t.categoryName ? t.categoryName + '：' + t.tagName : t.tagName) }}</el-checkbox>
                </el-checkbox-group>
                <div class="helper-desc" style="margin-top: 8px;">
                  <i class="el-icon-info"></i> 至少勾选一个；教师 H5 默认选中带有这些标签的学生。
                </div>
              </el-form-item>
            </el-tab-pane>

            <el-tab-pane name="time">
              <span slot="label"><i class="el-icon-time"></i> 放学及时间配置</span>
              
              <el-form-item label="放学时间" prop="DismissalTime">
                <el-time-select v-model="temp.DismissalTime" :picker-options="{
                  start: '07:00',
                  step: '00:05',
                  end: '23:00',
                }" placeholder="选择时间" style="width: 100%">
                </el-time-select>
              </el-form-item>
              
              <el-form-item label="显示时长" prop="DisplayDurationMinutes">
                <div class="input-with-unit">
                  <el-input-number v-model="temp.DisplayDurationMinutes" :min="1" :max="120" controls-position="right"></el-input-number>
                  <span class="unit-label">分钟</span>
                </div>
                <div class="helper-desc">
                  <i class="el-icon-info"></i> 默认30，表示放学动作后N分钟内大屏显示“放学中”，之后显示“已放学”
                </div>
              </el-form-item>
              
              <el-form-item label="统计窗口时长" prop="StatisticalWindowMinutes">
                <div class="input-with-unit">
                  <el-input-number v-model="temp.StatisticalWindowMinutes" :min="1" :max="120" controls-position="right"></el-input-number>
                  <span class="unit-label">分钟</span>
                </div>
                <div class="helper-desc helper-desc--success">
                  <i class="el-icon-success"></i> 从该班级第一个学生刷脸出校起，持续统计离校人数的时长。
                </div>
              </el-form-item>
              
              <el-form-item label="提前进入时段" prop="PreDismissalMinutes">
                <div class="input-with-unit">
                  <el-input-number v-model="temp.PreDismissalMinutes" :min="0" :max="120" controls-position="right"></el-input-number>
                  <span class="unit-label">分钟</span>
                </div>
                <div class="helper-desc">
                  <i class="el-icon-info"></i> 默认30，表示在预设放学时间前N分钟提前切换到该时段
                </div>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
          
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="saveData" :loading="submitLoading">确认</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import { getConfigList, saveConfig, deleteConfig, getDismissalTags } from "@/api/dismissal";
import { getSubGrades, getDepartmentListPage } from '../../api/modules/department';
import { getCampusList } from '../../api/modules/misc';
import DepartmentPane from "../../components/DepartmentPane";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import { toDeptId, treeNodeDeptId, normalizeDeptId } from '../../utils/deptCascaderProps';

export default {
  name: "TimeConfig",
  components: { DepartmentPane, Toolbar },
  data() {
    return {
      activeTab: "base",
      list: [],
      listLoading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      gradeOptions: [],
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑配置",
        create: "新增配置",
      },
      temp: {
        Id: 0,
        SchId: "",
        GradeId: null,
        PeriodName: "",
        ConfigTags: [],
        DismissalTime: "16:30",
        DisplayDurationMinutes: 30,
        SelfRetainedThresholdMinutes: 60,
        PreDismissalMinutes: 30,
        StatisticalWindowMinutes: 10,
      },
      campusTagOptions: [],
      lastTreeNode: null,
      tagSelectLoading: false,
      selectedConfigTagIds: [],
      defaultConfigTagIds: [],
      rules: {
        GradeId: [{ required: true, message: "请选择年级", trigger: "change" }],
        DismissalTime: [
          { required: true, message: "请选择放学时间", trigger: "change" },
        ],
      },
      submitLoading: false,
      currentSchId: '',
      currentCampusId: 0,
      currentDepartmentName: '',
      buttonList: [],
      searchList: [{ label: "年级名称", key: "GradeName" }],
      filters: {},
      currentRow: null,
    };
  },
  computed: {
    // 过滤出该校区启用且应用于放学的标签（增加非空强校验，过滤掉空文本垃圾数据）
    campusDismissalTags() {
      return (this.campusTagOptions || []).filter(
        (t) => this.isTagEnabled(t) && 
               this.isApplyToDismissal(t) && 
               !!(t.displayName || t.tagName)
      );
    },
    selectedDismissalTags() {
      const set = new Set(this.selectedConfigTagIds || []);
      return this.campusDismissalTags.filter((t) => set.has(t.id));
    },
    tagSelectHint() {
      if (this.tagSelectLoading) return "正在加载标签…";
      if (!this.temp.GradeId) return "请先选择年级，将按该年级所属校区加载标签";
      if (!this.currentCampusId) {
        return "未解析到校区：请确认机构树含校区节点，或在「放学标签配置」中为该校区维护标签";
      }
      if (!this.campusTagOptions.length) {
        return "该校区暂无标签，请先在「放学标签配置」中新增标签项";
      }
      if (!this.campusDismissalTags.length) {
        return "该校区暂无「应用于放学」且启用的标签，请在「放学标签配置」中开启";
      }
      return "";
    },
    tagSelectHintType() {
      if (this.tagSelectLoading) return "info";
      if (!this.temp.GradeId || !this.currentCampusId || !this.campusTagOptions.length) return "warn";
      if (!this.campusDismissalTags.length) return "warn";
      return "info";
    }
  },
  created() {
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
  methods: {
    configTagsOfRow(row) {
      return row.ConfigTags || row.configTags || [];
    },

    defaultTagsOfRow(row) {
      return this.configTagsOfRow(row).filter((t) => t.IsDefault || t.isDefault);
    },

    configTagLabel(t) {
      if (!t) return "";
      const displayName = t.DisplayName != null ? t.DisplayName : t.displayName;
      if (displayName) return displayName;
      const cat = t.CategoryName != null ? t.CategoryName : t.categoryName;
      const val = t.TagName != null ? t.TagName : t.tagName;
      if (cat && val) return `${cat}：${val}`;
      return val || cat || "";
    },

    treeNodeClick(data, node) {
      this.lastTreeNode = node || null;
      if (!data || data.value == "0") {
        this.$message.warning("请选择具体的学校或校区进行操作");
        this.currentSchId = "";
        this.currentCampusId = 0;
        this.currentDepartmentName = "";
        this.list = [];
        this.total = 0;
        this.page = 1;
        this.campusTagOptions = [];
        return;
      }
      this.currentSchId = data.value;
      this.currentDepartmentName = data.label;
      this.page = 1;
      this.handleQuery();
      this.fetchGrades();
      this.resolveCampusForContext(data, node).then(async (campusId) => {
        let cid = campusId;
        if (!normalizeDeptId(cid)) {
          cid = await this.fetchCampusIdUnderDepartment(data.value);
        }
        this.currentCampusId = cid;
        if (normalizeDeptId(cid)) {
          return this.fetchCampusTags(cid);
        }
        this.campusTagOptions = [];
      });
    },

    /** 从树节点向上找校区 Id（字符串）。最后修改：2026-10-18 */
    resolveCampusIdFromTreeNode(node) {
      let n = node;
      while (n && n.data) {
        const t = String((n.data.DeptOrgType != null ? n.data.DeptOrgType : n.data.deptOrgType) || "").toLowerCase();
        if (t === "campus") return treeNodeDeptId(n.data);
        n = n.parent;
      }
      return '';
    },

    async resolveCampusForContext(data, node) {
      if (!data) return '';
      const deptType = String(data.DeptOrgType != null ? data.DeptOrgType : data.deptOrgType || "").toLowerCase();
      if (deptType === "campus") return treeNodeDeptId(data);
      const fromTree = node ? this.resolveCampusIdFromTreeNode(node) : '';
      if (fromTree) return fromTree;
      const deptKey = treeNodeDeptId(data);
      if (deptKey) return this.resolveCampusIdForDepartment(deptKey);
      return '';
    },

    async resolveCampusForGrade(gradeId) {
      const fromTree = this.lastTreeNode ? this.resolveCampusIdFromTreeNode(this.lastTreeNode) : '';
      if (fromTree) return fromTree;

      const gradeKey = toDeptId(gradeId);
      if (gradeKey) {
        const fromGrade = await this.resolveCampusIdForDepartment(gradeKey);
        if (fromGrade) return fromGrade;
        const fromGradeCampusList = await this.fetchCampusIdUnderDepartment(gradeKey);
        if (fromGradeCampusList) return fromGradeCampusList;
      }

      const schId = toDeptId(this.currentSchId);
      if (schId) {
        const fromSch = await this.resolveCampusIdForDepartment(schId);
        if (fromSch) return fromSch;
        const fromSchCampusList = await this.fetchCampusIdUnderDepartment(schId);
        if (fromSchCampusList) return fromSchCampusList;
      }

      return '';
    },

    fetchCampusIdUnderDepartment(departmentId) {
      const deptId = toDeptId(departmentId);
      if (!deptId) return Promise.resolve('');
      return getCampusList({ page: 1, intPageSize: 999, departmentId: deptId }).then((res) => {
        if (!res.data.success || !res.data.response) return '';
        const list = res.data.response.data || res.data.response.Data || [];
        if (!list.length) return '';
        const c = list[0];
        return toDeptId(c.Id != null ? c.Id : c.id);
      });
    },

    isTagEnabled(t) {
      const v = t.isEnabled != null ? t.isEnabled : t.IsEnabled;
      if (v === undefined || v === null) return true;
      return v !== false && v !== 0 && v !== "0";
    },

    isApplyToDismissal(t) {
      const v = t.applyToDismissal != null ? t.applyToDismissal : t.ApplyToDismissal;
      if (v === undefined || v === null) return true;
      return v === true || v === 1 || v === "1" || v === "true" || v === "True";
    },

    async resolveCampusIdForDepartment(deptId) {
      let id = toDeptId(deptId);
      for (let i = 0; i < 12 && id; i++) {
        const res = await getDepartmentListPage({ id });
        if (!res.data.success || !res.data.response) return '';
        const dept = res.data.response;
        const t = String(dept.DeptOrgType != null ? dept.DeptOrgType : dept.deptOrgType || "").toLowerCase();
        if (t === "campus") return toDeptId(dept.Id);
        const pid = dept.Pid != null ? dept.Pid : dept.pid;
        id = toDeptId(pid);
        if (!id) return '';
      }
      return '';
    },

    onGradeChange(gradeId) {
      if (!gradeId) return;
      this.loadTagsForGrade(gradeId, true);
    },

    loadTagsForGrade(gradeId, clearSelectionOnFail) {
      this.tagSelectLoading = true;
      return this.resolveCampusForGrade(gradeId)
        .then((campusId) => {
          this.currentCampusId = campusId;
          if (normalizeDeptId(campusId)) {
            return this.fetchCampusTags(campusId);
          }
          this.campusTagOptions = [];
          if (clearSelectionOnFail) {
            this.selectedConfigTagIds = [];
            this.defaultConfigTagIds = [];
          }
        })
        .finally(() => {
          this.tagSelectLoading = false;
        });
    },

    onTagSelectVisible(open) {
      if (!open || !this.temp.GradeId) return;
      if (this.campusDismissalTags.length > 0 || this.tagSelectLoading) return;
      this.loadTagsForGrade(this.temp.GradeId, false);
    },

    fetchCampusTags(campusId) {
      const cid = campusId || this.currentCampusId;
      if (!cid) {
        this.campusTagOptions = [];
        return Promise.resolve();
      }
      return getDismissalTags({ campusId: cid })
        .then((res) => {
          if (res.data.success && res.data.response) {
            this.campusTagOptions = (res.data.response || []).map((t) => ({
              id: t.Id != null ? t.Id : t.id,
              categoryName: t.CategoryName != null ? t.CategoryName : t.categoryName,
              tagName: t.TagName != null ? t.TagName : t.tagName,
              displayName: t.DisplayName != null ? t.DisplayName : t.displayName,
              sortOrder: t.SortOrder != null ? t.SortOrder : t.sortOrder,
              applyToDismissal: t.ApplyToDismissal != null ? t.ApplyToDismissal : t.applyToDismissal,
              isEnabled: t.IsEnabled != null ? t.IsEnabled : t.isEnabled
            }));
          } else {
            this.campusTagOptions = [];
          }
        })
        .catch(() => {
          this.campusTagOptions = [];
        });
    },

    onConfigTagsChange(ids) {
      const set = new Set(ids || []);
      this.defaultConfigTagIds = (this.defaultConfigTagIds || []).filter((id) => set.has(id));
    },

    syncConfigTagsFromRow(row) {
      const raw = row.ConfigTags || row.configTags || [];
      this.selectedConfigTagIds = raw.map((t) => (t.TagId != null ? t.TagId : t.tagId)).filter((id) => id > 0);
      this.defaultConfigTagIds = raw
        .filter((t) => t.IsDefault || t.isDefault)
        .map((t) => (t.TagId != null ? t.TagId : t.tagId))
        .filter((id) => id > 0);
    },

    buildConfigTagsPayload() {
      const ids = this.selectedConfigTagIds || [];
      const defaultSet = new Set(this.defaultConfigTagIds || []);
      return ids.map((tagId, idx) => {
        const t = this.campusTagOptions.find((x) => x.id === tagId);
        return {
          TagId: tagId,
          CategoryName: t ? t.categoryName : "",
          TagName: t ? t.tagName : "",
          DisplayName: t ? (t.displayName || (t.categoryName ? `${t.categoryName}：${t.tagName}` : t.tagName)) : "",
          SortOrder: idx,
          IsDefault: defaultSet.has(tagId),
          ApplyToDismissal: t ? t.applyToDismissal : true
        };
      });
    },
    callFunction(item) {
      if (typeof item.search == "object") {
        this.filters = item.search;
      } else {
        this.filters = {
          key: item.search,
        };
      }
      if (item.Func === "handleQuery") {
        this.page = 1;
      }
      if (this[item.Func]) {
        this[item.Func].apply(this, item);
      } else {
        console.warn(`Function ${item.Func} not implemented`);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.setCurrentRow(val);
      }
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    handleQuery() {
      if (!this.currentSchId) return;
      this.listLoading = true;
      let params = {
        schId: this.currentSchId,
        page: this.page,
        intPageSize: this.pageSize,
        ...this.filters,
      };
      getConfigList(params)
        .then((res) => {
          if (res.data.success && res.data.response) {
            const pageData = res.data.response;
            this.list = pageData.data || [];
            this.total = pageData.dataCount || 0;
            this.page = pageData.page || this.page;
          } else {
            this.list = [];
            this.total = 0;
          }
          this.currentRow = null;
          this.listLoading = false;
        })
        .catch(() => {
          this.list = [];
          this.total = 0;
          this.listLoading = false;
        });
    },
    fetchGrades(schId) {
      const id = schId || this.currentSchId;
      if (!id) return;
      getSubGrades({ pid: id }).then((res) => {
        if (res.data.success) {
          this.gradeOptions = res.data.response.map((d) => ({
            label: d.Name,
            value: d.Id,
          }));
        } else {
          this.gradeOptions = [];
        }
      });
    },
    resetTemp() {
      this.temp = {
        Id: 0,
        SchId: this.currentSchId,
        GradeId: null,
        PeriodName: "",
        ConfigTags: [],
        DismissalTime: "16:30",
        DisplayDurationMinutes: 30,
        SelfRetainedThresholdMinutes: 60,
        PreDismissalMinutes: 30,
        StatisticalWindowMinutes: 10,
      };
      this.selectedConfigTagIds = [];
      this.defaultConfigTagIds = [];
    },
    handleAdd() {
      if (!this.currentSchId) {
        this.$message.warning("请先选择左侧学校或校区");
        return;
      }
      this.resetTemp();
      this.activeTab = "base";
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        if (this.$refs["dataForm"]) this.$refs["dataForm"].clearValidate();
      });
    },
    handleEdit(row) {
      if (!row || row.type === "click") {
        row = this.currentRow;
      }
      if (!row) {
        this.$message.warning("请选择要编辑的数据");
        return;
      }
      this.activeTab = "base";

      const targetSchId = row.SchId || this.currentSchId;
      this.fetchGrades(targetSchId);

      this.temp = {
        Id: row.Id,
        SchId: targetSchId,
        GradeId: row.GradeId,
        PeriodName: row.PeriodName,
        ConfigTags: row.ConfigTags || row.configTags || [],
        DismissalTime: row.DismissalTime,
        DisplayDurationMinutes: row.DisplayDurationMinutes,
        SelfRetainedThresholdMinutes: row.SelfRetainedThresholdMinutes,
        PreDismissalMinutes: (row.PreDismissalMinutes !== null && row.PreDismissalMinutes !== undefined) ? row.PreDismissalMinutes : 30,
        StatisticalWindowMinutes: row.StatisticalWindowMinutes || 10,
      };
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.syncConfigTagsFromRow(row);
      this.loadTagsForGrade(row.GradeId, false);
      this.$nextTick(() => {
        if (this.$refs["dataForm"]) this.$refs["dataForm"].clearValidate();
      });
    },
    saveData() {
      this.$refs["dataForm"].validate((valid, invalidFields) => {
        if (valid) {
          if (this.selectedConfigTagIds.length && !this.defaultConfigTagIds.length) {
            this.$message.warning("已关联标签时请至少指定一个默认勾选标签");
            return;
          }
          this.submitLoading = true;
          const params = {
            ...this.temp,
            ConfigTags: this.buildConfigTagsPayload()
          };
          saveConfig(params)
            .then((res) => {
              if (res.data.success) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.dialogFormVisible = false;
                this.handleQuery();
              } else {
                this.$message.error(res.data.msg || "保存失败");
              }
              this.submitLoading = false;
            })
            .catch((e) => {
              this.submitLoading = false;
              this.$message.error("保存异常");
            });
        } else {
          // 智能切换Tab：若基础配置的字段有错，自动切回 base，否则切到 time
          if (invalidFields) {
            const hasBaseError = Object.keys(invalidFields).some((key) =>
              ["GradeId", "PeriodName"].includes(key)
            );
            if (hasBaseError) {
              this.activeTab = "base";
            } else {
              this.activeTab = "time";
            }
          }
        }
      });
    },
    handleDel(row) {
      if (!row || row.type === "click") {
        row = this.currentRow;
      }
      if (!row) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除配置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteConfig({ id: row.Id }).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.handleQuery();
            } else {
              this.$message.error(res.data.msg || "删除失败");
            }
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style scoped>
.config-tag-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-start;
  padding: 4px 0;
}
.config-tag-pill {
  display: inline-block;
  padding: 4px 12px;
  font-size: 12px;
  line-height: 18px;
  color: #2563eb;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 16px;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.05);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.config-tag-pill:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 6px rgba(37, 99, 235, 0.15);
  background: #dbeafe;
}
.config-tag-pill--default {
  color: #16a34a;
  background: #f0fdf4;
  border-color: #bbf7d0;
  box-shadow: 0 1px 2px rgba(22, 163, 74, 0.05);
}
.config-tag-pill--default:hover {
  background: #dcfce7;
  box-shadow: 0 3px 6px rgba(22, 163, 74, 0.15);
}
.config-tag-empty {
  color: #909399;
  font-size: 12px;
}
.config-tag-muted {
  color: #c0c4cc;
  font-size: 12px;
}

/* 所属机构卡片样式 */
.org-display-card {
  display: inline-flex;
  align-items: center;
  padding: 10px 16px;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  margin: 12px 0 20px;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.05);
  font-size: 14px;
  transition: all 0.3s ease;
}
.org-display-card:hover {
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
  transform: translateY(-1px);
}
.org-icon {
  color: #3b82f6;
  font-size: 16px;
  margin-right: 8px;
  animation: pulse 2s infinite;
}
.org-label {
  color: #1e3a8a;
  font-weight: 500;
}
.org-value {
  color: #2563eb;
  font-weight: 600;
}
@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.08); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
}

/* 放学时间时钟徽章 */
.time-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  background-color: #f0f7ff;
  color: #0066ff;
  border: 1px solid #c2e0ff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  font-family: Monaco, monospace;
}
.time-icon {
  margin-right: 6px;
  font-size: 14px;
}

/* 表单分区样式 */
.form-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  margin: 18px 0 16px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #e2e8f0;
  display: flex;
  align-items: center;
  gap: 6px;
}
.form-section-title:first-of-type {
  margin-top: 0;
}
.form-section-title i {
  color: #3b82f6;
  font-size: 16px;
}

/* 带单位的输入框 */
.input-with-unit {
  display: flex;
  align-items: center;
  gap: 10px;
}
.unit-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

/* 默认勾选标签多选框美化 */
.modern-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
::v-deep .modern-checkbox-group .el-checkbox {
  margin: 0 !important; /* 彻底清除 Element 的 margin 干扰，完全交给 flex gap 控制，解决折行偏离 */
  width: 160px; /* 固定宽度，确保每一块宽度一致、整齐划一 */
  box-sizing: border-box; /* 包含 border 和 padding 计算宽度 */
  display: inline-flex; /* 使用 flex 布局，方便对齐 */
  align-items: center;
  border-radius: 6px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 8px 12px;
  height: auto;
  transition: all 0.2s ease;
}
::v-deep .modern-checkbox-group .el-checkbox.is-checked {
  background-color: #ecfdf5;
  border-color: #10b981;
}
::v-deep .modern-checkbox-group .el-checkbox.is-checked .el-checkbox__label {
  color: #065f46 !important;
}
::v-deep .modern-checkbox-group .el-checkbox__label {
  color: #475569;
  padding-left: 8px;
}

/* 辅助提示文字 */
.helper-desc {
  font-size: 12px;
  line-height: 1.6;
  color: #64748b;
  margin-top: 6px;
  display: flex;
  align-items: flex-start;
  gap: 4px;
}
.helper-desc i {
  margin-top: 3px;
  font-size: 13px;
}
.helper-desc--success {
  color: #16a34a;
  background-color: #f0fdf4;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #dcfce7;
  margin-top: 8px;
}

/* 窄屏响应式优化 */
.tag-select-hint {
  font-size: 12px;
  line-height: 1.5;
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.tag-select-hint--warn {
  color: #ea580c;
}
.tag-select-hint--info {
  color: #64748b;
}

@media (max-width: 992px) {
  ::v-deep .el-dialog {
    width: 92% !important;
  }
  ::v-deep .el-dialog .el-form-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
    margin-bottom: 16px;
  }
  ::v-deep .el-dialog .el-form-item__label {
    width: 100% !important;
    text-align: left !important;
    padding: 0 0 6px !important;
    line-height: 1.35 !important;
    font-weight: 600;
    color: #334155;
  }
  ::v-deep .el-dialog .el-form-item__content {
    margin-left: 0 !important;
    width: 100% !important;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  ::v-deep .el-dialog .el-form-item__content .el-input-number {
    width: 100% !important;
    max-width: 200px;
  }
}

/* 弹窗 Tab 样式美化 */
::v-deep .dialog-tabs .el-tabs__header {
  margin: 0 0 24px;
}
::v-deep .dialog-tabs .el-tabs__item {
  font-weight: 500;
  color: #64748b;
  font-size: 14px;
  padding: 0 20px 10px;
}
::v-deep .dialog-tabs .el-tabs__item.is-active {
  color: #3b82f6;
  font-weight: 600;
}
::v-deep .dialog-tabs .el-tabs__active-bar {
  background-color: #3b82f6;
  height: 3px;
  border-radius: 2px;
}
::v-deep .dialog-tabs .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #f1f5f9;
}
</style>